import {JsonApiModelConfig, Attribute, JsonApiModel} from 'angular2-jsonapi';

@JsonApiModelConfig({
  type: 'address'
})
export class Address extends JsonApiModel {
  @Attribute()
  street: string;
  @Attribute()
  zip: number;
  @Attribute()
  city: string;
  @Attribute()
  lat: number;
  @Attribute()
  lng: number;

}




// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/models/address.ts